import type { Theme } from "@albertine/types/openapi/lmt";
import { Flex } from "../Common/Flex";
import FullScreenOverlay from "../Common/Overlay/FullScreenOverlay";
import ThemeForm from "./StaticThemeForm";
import "./EditTheme.css";
import ItemNotFound from "../CatalogBeta/ItemNotFound";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import DynamicThemeForm from "./DynamicThemeForm";
import { WithTheme } from "./WithTheme";

type EditThemeProps = {
    themeId: string;
    onBack: () => void;
    onDelete: () => void;
    onSave: (theme: Theme) => void;
};

function EditTheme(props: EditThemeProps) {
    const { themeId, onBack, onDelete, onSave } = props;

    return (
        <FullScreenOverlay>
            <Flex.Row className="edit-theme__title">
                <h2>Edit theme</h2>
            </Flex.Row>

            <WithTheme
                renderOnError={
                    <ItemNotFound
                        contentItemId={themeId}
                        onClose={() => {
                            onBack();
                        }}
                    />
                }
                renderLoading={
                    <Flex.Column
                        className="edit-theme__loading"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <LoadingSpinner />
                    </Flex.Column>
                }
                themeId={themeId}
            >
                {(theme) =>
                    theme.content.every((it) => it.type === "static") ? (
                        <ThemeForm
                            theme={theme}
                            onCancel={onBack}
                            onDelete={onDelete}
                            onSave={onSave}
                        />
                    ) : (
                        <DynamicThemeForm
                            theme={theme}
                            onCancel={onBack}
                            onSave={onSave}
                        />
                    )
                }
            </WithTheme>
        </FullScreenOverlay>
    );
}

export default EditTheme;
